import React from 'react';
import Proptypes from 'prop-types';

import { MText } from '../../../../atoms/MText';
import MCheckBox from '../../../../atoms/MCheckBox';

import PriceDetails from '../../../../molecules/PriceDetails';
import ProductActionButtons from '../../../../molecules/ProductActionButtons';

import MFlexbox from '../../../../atoms/MFlexbox';

import { StyledFBTProductItemCon } from './skins';

export default function FBTProduct(props) {
  const {
    idx,
    isMobile,
    product,
    selectedVariant,
    theme,
    priceDetailStyles,
    getProductAndSelectedVariantData,
    productActionButtonStyles,
    checkedProductsInfo,
    handleFBTCheckboxchange,
    widgetContainerWidth,
  } = props;

  // destructuring curr product item and selected variant data
  // go to function defination for each variable info
  const {
    variantOptions,
    showVariantSelector,
    handleVariantChange,
    variantFiller,
    variantFillerPadding,
    fbtProductPriceDetails,
    onProductTitleClick,
  } = getProductAndSelectedVariantData(product, selectedVariant);

  if (productActionButtonStyles.variantSelectorWidth === '0') {
    productActionButtonStyles.variantSelectorWidth = Math.max(
      widgetContainerWidth * 0.2,
      90,
    );
  }

  const productActionButtonsProps = {
    quantityAdded: null,
    showVariantSelector,
    showATCButton: false,
    isProductAdditionEnabled: false,
    variantFiller,
    variantFillerPadding,
    variantSelectorValue: selectedVariant.title,
    variantSelectorOptions: variantOptions,
    handleVariantChange,
    ...productActionButtonStyles,
  };

  return (
    <>
      <StyledFBTProductItemCon
        padding={
          isMobile ? theme.productItemMobilePadding : theme.productItemPadding
        }
        margin={
          isMobile ? theme.productItemMobileMargin : theme.productItemMargin
        }
        className="mr-product-item mr-product-item--fbt"
        gap="8px"
      >
        <MCheckBox
          className="mr-product-item__checkbox"
          onChange={() => handleFBTCheckboxchange(idx)}
          checked={checkedProductsInfo[idx]}
          borderColor={theme.fbtCheckboxBorderColor}
          borderRadius={theme.fbtCheckboxBorderRadius}
          tickBgColor={theme.fbtCheckboxTickBackgroundColor}
          tickColor={theme.fbtCheckboxTickColor}
          width="24"
          margin="auto 0px"
        />
        <MFlexbox
          gap="8px"
          ai="center"
          className="mr-product-item__body mr-grow"
          opacity={checkedProductsInfo[idx] ? '1' : '0.5'}
        >
          <MFlexbox
            flexDir="column"
            jc="center"
            ai="baseline"
            gapColumn="8px"
            className="mr-product-item__details mr-grow"
          >
            <MText
              color={theme.productNameTextColor}
              fontSize={
                isMobile
                  ? theme.productNameMobileFontSize
                  : theme.productNameFontSize
              }
              mobileFontSize={theme.productNameMobileFontSize}
              fontStyle={theme.productNameFontStyle}
              fontWeight={theme.fbtProductNameFontWeight}
              textDecoration={theme.productNameTextDecoration}
              fontFamily={theme.productNameFontFamily}
              textAlignment={theme.productNameTextAlignment}
              padding={
                isMobile
                  ? theme.productNameMobilePadding
                  : theme.productNamePadding
              }
              margin={
                isMobile
                  ? theme.productNameMobileMargin
                  : theme.productNameMargin
              }
              width="100%"
              className="mr-product-details__fbt-product-name-con"
            >
              {idx === 0 && (
                <>
                  <MText
                    isInlineText
                    fontSize={
                      isMobile
                        ? theme.fbtThisItemMobileFontSize
                        : theme.fbtThisItemFontSize
                    }
                    mobileFontSize={theme.fbtThisItemMobileFontSize}
                    color={theme.fbtThisItemTextColor}
                    fontStyle={theme.fbtThisItemFontStyle}
                    fontWeight={theme.fbtThisItemFontWeight}
                    textDecoration={theme.fbtThisItemTextDecoration}
                    fontFamily={theme.fbtThisItemFontFamily}
                    // textAlignment={theme.fbtThisItemTextAlignment}
                    // padding={theme.fbtThisItemPadding}
                    // margin={theme.fbtThisItemMargin}
                    className="mr-fbt-product-name-con__this-item"
                  >
                    {theme.fbtThisItemText}
                  </MText>
                  &nbsp;
                </>
              )}
              <MText
                onTextClick={onProductTitleClick}
                cursor={theme.isProductTitleClickGoToPage ? 'pointer' : 'auto'}
                className="mr-fbt-product-name-con__product-name"
              >
                {product.title}
              </MText>
              &nbsp;
              <PriceDetails
                isInline
                offerPrice={fbtProductPriceDetails.offerPrice}
                price={fbtProductPriceDetails.price}
                off={fbtProductPriceDetails.off}
                isDiscountDisabled={fbtProductPriceDetails.isDiscountDisabled}
                {...priceDetailStyles}
                fontFamily={theme.productPriceFontFamily}
                padding={
                  isMobile
                    ? theme.productPriceMobilePadding
                    : theme.productPricePadding
                }
                margin={
                  isMobile
                    ? theme.productPriceMobileMargin
                    : theme.productPriceMargin
                }
                flexWrap="nowrap"
                className="mr-fbt-product-name-con__product-price"
              />
            </MText>
            {product.description && (
              <MText
                color={theme.productDescriptionTextColor}
                fontSize={
                  isMobile
                    ? theme.productDescriptionMobileFontSize
                    : theme.productDescriptionFontSize
                }
                mobileFontSize={theme.productNameMobileFontSize}
                fontStyle={theme.productDescriptionFontStyle}
                fontWeight={theme.productDescriptionFontWeight}
                textDecoration={theme.productDescriptionTextDecoration}
                fontFamily={theme.productDescriptionFontFamily}
                textAlignment={
                  isMobile
                    ? theme.productDescriptionMobileTextAlignment
                    : theme.productDescriptionTextAlignment
                }
                padding={theme.productDescriptionPadding}
                margin={theme.productDescriptionMargin}
                width="100%"
                className="mr-product-details__product-description"
              >
                {product.description}
              </MText>
            )}
          </MFlexbox>
          {/* <div className="mr-action-wrapper"> */}
          <ProductActionButtons
            layout="vertical"
            {...productActionButtonsProps}
          />
          {/* </div> */}
        </MFlexbox>
      </StyledFBTProductItemCon>
    </>
  );
}

FBTProduct.propTypes = {
  isMobile: Proptypes.bool.isRequired,
  product: Proptypes.object.isRequired,
  selectedVariant: Proptypes.object.isRequired,
  theme: Proptypes.object.isRequired,
  getProductAndSelectedVariantData: Proptypes.func.isRequired,
  productActionButtonStyles: Proptypes.object.isRequired,
  checkedProductsInfo: Proptypes.array.isRequired,
  handleFBTCheckboxchange: Proptypes.func.isRequired,
  idx: Proptypes.number,
  widgetContainerWidth: Proptypes.number,
  priceDetailStyles: Proptypes.object,
};
